module.exports = __webpack_public_path__ + "img/jacket-back-sub-raglan-zipper.98f90ce7.png";